// extracted by mini-css-extract-plugin
export default {"EditorStyle":"MonacoEditorJSON_EditorStyle__-BsNt"};